export class SetLoading {
  static readonly type = '[LayoutState] SetLoading';
  constructor(public loading: boolean) {}
}

export class ToggleDarkTheme {
  static readonly type = '[LayoutState] ToggleDarkTheme';
}
